import classOperation from '@/api/class-operation'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  ac_status_id: [1, 3],
  editData: [],
  yearList: [],
  termList: [],
  teacherList: [],
  building: [],
  studyTimes: [],
  categories: [],
  classLists: [],
  all_year: false,
  history: false,
  branch_id: null,
  acYearFilter: [], // use in table list filter,
  isHasEnrollment: undefined
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.editData = data
  },
  SET_YEAR_LIST(state, data) {
    state.yearList = data
  },
  SET_TERM_LIST(state, data) {
    state.termList = data
  },
  SET_TEACH_LIST(state, data) {
    state.teacherList = data
  },
  SET_BUILDING_LIST(state, data) {
    state.building = data
  },
  SET_STUDY_TIME_LIST(state, data) {
    state.studyTimes = data
  },
  SET_CATEGORY_LIST(state, data) {
    state.categories = data
  },
  SET_CLASS_LIST(state, data) {
    state.classLists = data ? data : []
  },
  SET_ALL_YEAR_FETCH(state, value) {
    state.all_year = value
  },
  SET_STATUS_ID(state, value) {
    state.ac_status_id = value
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_ACYEAR_ID_FILTER(state, data) {
    state.acYearFilter = data
  },
  SET_HAS_ENROLMENT_FILTER(state, data) {
    state.isHasEnrollment = data
  }
}

export const actions = {
  async fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          ac_status_id: _.join(context.state.ac_status_id, ','),
          ac_year_id: _.join(context.state.acYearFilter, ','),
          has_enrollment: context.state.isHasEnrollment
        }
      },
      attrubutes
    )
    // get all list class
    // await context.dispatch('getListClass')
    return await classOperation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return classOperation.store(data)
  },

  copyClass(context, data) {
    return classOperation.copyClass(data)
  },

  update(context, { id, data }) {
    return classOperation.update(id, data)
  },
  destroy(context, id) {
    return classOperation.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.editData)) {
      let response = await classOperation.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getListClass(context) {
    let response = await classOperation.getListClass()
    context.commit('SET_CLASS_LIST', response.data)
  },
  async getAcademicYear(context) {
    let responsegetYear = await classOperation.getYear()
    context.commit('SET_YEAR_LIST', responsegetYear.data)
    return responsegetYear;
  },
  async dataBeforeCreate(context) {
    let responsegetYear = await classOperation.getYear()
    context.commit('SET_YEAR_LIST', responsegetYear.data)

    let responsegetTerm = await classOperation.getTerm()
    context.commit('SET_TERM_LIST', responsegetTerm.data)

    let responsegetTeacher = await classOperation.getTeacher()
    context.commit('SET_TEACH_LIST', responsegetTeacher.data)

    let responsegetBuilding = await classOperation.getBuilding()
    context.commit('SET_BUILDING_LIST', responsegetBuilding.data)

    let responsegetStudyTime = await classOperation.getStudyTime()
    context.commit('SET_STUDY_TIME_LIST', responsegetStudyTime.data)

    let responsegetCategoryClass = await classOperation.getCategoryClass()
    context.commit('SET_CATEGORY_LIST', responsegetCategoryClass.data)

    context.dispatch('getListClass')
  },

  async getMainAndSub(context, acps_id) {
    return await classOperation.getMainAndSub(acps_id)
  },

  async getLevel(context, acps_id) {
    return await classOperation.getLevel(acps_id)
  },

  async getClassAllowSwap(context, acps_id) {
    return await classOperation.getClassAllowSwap(acps_id)
  }
}
